import { render, staticRenderFns } from "./assays-view-modal.vue?vue&type=template&id=31746da0&scoped=true&"
import script from "./assays-view-modal.ts?vue&type=script&lang=ts&"
export * from "./assays-view-modal.ts?vue&type=script&lang=ts&"
import style0 from "./assays-view-modal.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./assays-view-modal.scoped.scss?vue&type=style&index=1&id=31746da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31746da0",
  null
  
)

export default component.exports